"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function removeElementById(elementId) {
    const element = global.document.getElementById(elementId);
    if (element)
        element.parentNode.removeChild(element);
}
exports.default = removeElementById;
